<template>
  <div
    v-if="!dismissed"
    class="sticky top-0 z-[2010] flex w-full items-center justify-center gap-2.5 bg-linear-to-r from-amber-400 to-amber-500 px-14 py-3 text-center text-sm font-semibold leading-snug tracking-wide text-amber-950 shadow-md"
    data-cy="high-memory-banner"
    role="alert"
  >
    <svg
      class="h-5 w-5 shrink-0"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M12 9v4m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <span>{{ t("warning.high-memory-restart") }}</span>
    <button
      type="button"
      class="absolute inset-y-0 right-3 flex cursor-pointer items-center px-2"
      data-cy="high-memory-banner-close"
      :aria-label="t('button.close')"
      @click="dismiss"
    >
      <i class="s-icon s-icon--x text-xl" aria-hidden="true" />
    </button>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import { useI18n } from "vue-i18n";
import { LogService } from "@/services/logging";
import { SessionStorageKeys } from "@/services/storage.service";

/**
 * Shown when memory stays above the threshold after a memory reload (L3-8422)
 */
export default defineComponent({
  name: "HighMemoryBanner",
  setup() {
    const { t } = useI18n({});
    const dismissed = ref(
      sessionStorage.getItem(SessionStorageKeys.MemoryBannerDismissed) === "1"
    );

    function dismiss() {
      sessionStorage.setItem(SessionStorageKeys.MemoryBannerDismissed, "1");
      dismissed.value = true;
      LogService.info("High memory banner dismissed by the user");
    }

    return { t, dismissed, dismiss };
  },
});
</script>
